import classNames from "classnames";
import React, { useState } from "react";
import { FaGear } from "react-icons/fa6";
import { FiLogOut, FiMenu } from "react-icons/fi";
import { IoClose } from "react-icons/io5";
import { MdOutlineSupportAgent } from "react-icons/md";
import {
  Menu,
  MenuItem,
  ProSidebarProvider,
  Sidebar,
  SubMenu,
} from "react-pro-sidebar";
import { useMediaQuery } from "react-responsive";
import { Link, useLocation } from "react-router-dom";
import MainLogo from "../../assets/images/logo.jpg";

import logoPlaceholder from "../../assets/images/logoPlaceholder.png";
import { useNavbar } from "../../customHooks/Navbar/useNavbar";

import styles from "./NavBar.module.css";

const NavBar = () => {
  const hookProps = useNavbar();
  const location = useLocation();

  const {
    openAlert,
    handleClose,
    handleLogout,
    handleOpen,
    modules,
    openIndex,
    setOpenIndex,
    handleItemClick,
    tabs,
  } = hookProps;
  const isDesktop = useMediaQuery({ minWidth: 768 });
  const [isCollapsed, setIsCollapsed] = useState(false);
  const handleToggle = () => {
    setIsCollapsed(!isCollapsed);
  };
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  return (
    <>
      {isDesktop ? (
        <>
          <ProSidebarProvider>
            <Sidebar className={styles.leftsidebar} collapsed={isCollapsed}>
              {/* Logo Section */}
              <div className={styles.mainlogo}>
                <Link to={"/"} className="no-underline hover:no-underline">
                  {isCollapsed ? null : (
                    <img
                      src={MainLogo}
                      alt="client_logo"
                      className="max-w-full h-10 object-contain"
                    />
                  )}
                </Link>
                {/* Menu Toggle Icon */}
                <div className={styles.menuicon}>
                  <FiMenu
                    size={26}
                    onClick={handleToggle}
                    style={{ cursor: "pointer" }}
                  />
                </div>
              </div>

              {/* Sidebar Menu */}
              <Menu className={styles.navbarMenu}>
                {tabs.length > 0 &&
                  tabs?.map((item, index) => (
                    <div key={index}>
                      {item.subItems ? (
                        <SubMenu
                          label={item.title}
                          icon={item.icon}
                          open={openIndex === index}
                          onClick={() => handleItemClick(index)}
                          className={`${
                            new RegExp(
                              `/${item.title
                                .replace(/\s+/g, "")
                                .toLowerCase()}$`
                            ).test(location.pathname)
                              ? "text-blue-600"
                              : ""
                          }`}
                        >
                          {item.subItems.map((child, childIndex) => (
                            <MenuItem
                              key={childIndex}
                              icon={child.icon}
                              component={
                                <Link
                                  to={`/${child.title
                                    .replace(/\s+/g, "")
                                    .toLowerCase()}`}
                                />
                              }
                              className={classNames(styles.subLink, {
                                [styles.activeSubLink]: new RegExp(
                                  `/${child.title
                                    .replace(/\s+/g, "")
                                    .toLowerCase()}$`
                                ).test(location.pathname),
                              })}
                            >
                              {child.title}
                            </MenuItem>
                          ))}
                        </SubMenu>
                      ) : (
                        item.title !== "Settings" && (
                          <>
                            <MenuItem
                              component={
                                <Link
                                  to={`/${item.title
                                    .replace(/\s+/g, "")
                                    .toLowerCase()}`}
                                />
                              }
                              icon={item.icon}
                              onClick={() => setOpenIndex(null)} // Close any open SubMenu
                              className={classNames({
                                [styles.activeLink]: new RegExp(
                                  `/${item.title
                                    .replace(/\s+/g, "")
                                    .toLowerCase()}$`
                                ).test(location.pathname),
                              })}
                            >
                              {item.title}
                            </MenuItem>
                          </>
                        )
                      )}
                    </div>
                  ))}
              </Menu>

              {/* <div
                className={`${
                  location.pathname.includes("/settings")
                    ? `${styles.bgverification} text-white`
                    : ""
                } hover:no-underline hover:text-black  ${styles.logouticon}`}
              >
                <Menu>
                  <MenuItem
                    icon={
                      <MdSettings
                        className={`${
                          location.pathname.includes("/settings")
                            ? `${styles.bgverification} text-white`
                            : ""
                        } hover:no-underline `}
                      />
                    }
                  >
                    <Link
                      to={"/settings"}
                      className={`${
                        location.pathname.includes("/settings")
                          ? `${styles.bgverification} text-white`
                          : ""
                      } hover:no-underline text-black`}
                    >
                      Settings
                    </Link>
                  </MenuItem>
                </Menu>
              </div> */}
              {/* Logout Button */}
              <div
                className={classNames(styles.logouticon, "mt-auto bg-white")}
              >
                {tabs?.length > 0 &&
                  tabs?.some((item) => item.title === "Settings") && (
                    <Menu>
                      <MenuItem icon={<FaGear />} onClick={goToSettings}>
                        Settings
                      </MenuItem>
                    </Menu>
                  )}
                <Menu>
                  {/* <MenuItem
                    icon={<MdOutlineSupportAgent />}
                    component={<Link to={`/contactus`} />}
                    className="border-b border-collapse"
                  >
                    Contact Us
                  </MenuItem> */}
                  <MenuItem icon={<FiLogOut />} onClick={handleLogout}>
                    Logout
                  </MenuItem>
                </Menu>
              </div>
            </Sidebar>
          </ProSidebarProvider>
        </>
      ) : (
        <>
          <div>
            {/* Top Navbar */}
            <nav className={styles.topNavbar}>
              <div className={styles.logo}>
                <Link to={"/"}>
                  <img
                    src="/iAugment-logo-color.png"
                    alt="Logo"
                    className={styles.mainLogo}
                  />
                </Link>
              </div>
              <div className={styles.menuIcon}>
                {!isMenuOpen ? (
                  <FiMenu
                    size={26}
                    onClick={toggleMenu}
                    style={{ cursor: "pointer" }}
                  />
                ) : (
                  <IoClose
                    size={26}
                    onClick={toggleMenu}
                    style={{ cursor: "pointer" }}
                  />
                )}
              </div>
            </nav>

            {/* Dropdown Menu */}
            {isMenuOpen && (
              <div className={styles.menuWrapper}>
                <ul className={styles.menuList}>
                  {tabs?.map((item, index) => (
                    <li key={index} className={styles.menuItem}>
                      {item.subItems ? (
                        <details className={styles.subMenu}>
                          <summary className={styles.subMenuLabel}>
                            {item.icon}
                            {item.title}
                          </summary>
                          <ul className={styles.subMenuList}>
                            {item.subItems.map((child, childIndex) => (
                              <li key={childIndex}>
                                <Link
                                  to={`/${child.title
                                    .replace(/\s+/g, "")
                                    .toLowerCase()}`}
                                  className={classNames({
                                    [styles.activeSubLink]:
                                      location.pathname.includes(
                                        child.title
                                          .replace(/\s+/g, "")
                                          .toLowerCase()
                                      ),
                                  })}
                                  onClick={() => setIsMenuOpen(false)}
                                >
                                  {child.icon}
                                  {child.title}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </details>
                      ) : (
                        <Link
                          to={`/${item.title
                            .replace(/\s+/g, "")
                            .toLowerCase()}`}
                          className={classNames({
                            [styles.activeLink]: location.pathname.includes(
                              item.title.replace(/\s+/g, "").toLowerCase()
                            ),
                          })}
                          onClick={() => setIsMenuOpen(false)}
                        >
                          {item.icon}
                          {item.title}
                        </Link>
                      )}
                    </li>
                  ))}
                  {/* Logout Button */}
                  {/* <li className={styles.menuItem}>
                    <Link
                      to={"/settings"}
                      className={`${
                        location.pathname.includes("settings")
                          ? "text-blue-600"
                          : ""
                      }`}
                    >
                      <MdSettings fontSize={20} className="-ml-1" />
                      Settings
                    </Link>
                  </li> */}
                  {/* <li className={styles.menuItem}>
                    <Link
                      to={"/contactus"}
                      className={classNames({
                        [styles.activeLink]:
                          location.pathname.includes("contactus"),
                      })}
                      onClick={() => setIsMenuOpen(false)}
                    >
                      <MdOutlineSupportAgent />
                      Contact Us
                    </Link>
                  </li> */}
                  <li className={styles.menuItem}>
                    <button
                      onClick={handleLogout}
                      className={styles.logoutButton}
                    >
                      <FiLogOut /> Logout
                    </button>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default NavBar;
